var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "60px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-flickr",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx1}}",
    cy: 50,
    "ng-attr-fill": "{{config.c1}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 44.7902,
    fill: "#0064AD",
    r: 40
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "30;100;30",
    keyTimes: "0;0.5;1",
    dur: 1.8,
    begin: "-0.9s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx2}}",
    cy: 50,
    "ng-attr-fill": "{{config.c2}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 55.2098,
    fill: "#1e3352",
    r: 40
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "30;100;30",
    keyTimes: "0;0.5;1",
    dur: 1.8,
    begin: "0s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "ng-attr-cx": "{{config.cx1}}",
    cy: 50,
    "ng-attr-fill": "{{config.c1}}",
    "ng-attr-r": "{{config.radius}}",
    cx: 44.7902,
    fill: "#0064AD",
    r: 40
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "linear",
    values: "30;100;30",
    keyTimes: "0;0.5;1",
    dur: 1.8,
    begin: "-0.9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0;1;1",
    calcMode: "discrete",
    keyTimes: "0;0.499;0.5;1",
    "ng-attr-dur": "{{config.speed}}s",
    repeatCount: "indefinite",
    dur: "1.8s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.455661fb902e4e7d9e97843231640056.svg";
export { ForwardRef as ReactComponent };